module.exports = __webpack_public_path__ + "static/media/image1.233df274.png";